module.exports = __webpack_public_path__ + "img/white_combine.26908bed.png";